module.exports = __webpack_public_path__ + "media/new/sample-course-f1379691.gif";